import { KYMW0A00Model } from '../kymw0a00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * Ｐコードリストを取得するサービス
 *
 * @export GetPcodeList0AService
 * @class GetPcodeList0AService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPcodeList0AService extends PlessJsonResponderSub<any> {

  private model: KYMW0A00Model = null;
  private selectPcode: Array<string>;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPcodeList0AService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetPcodeList: {
          combination: this.selectPcode.map((pcode) => {
            return {
              condition: {
                Pcode: pcode
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model KYMW0A00Model
   * @memberof GetPcodeList0AService
   */
  execute(model: KYMW0A00Model, selectPcode: Array<string>): void {
    this.model = model;
    this.selectPcode = selectPcode;
    this.send('getPcodeList0A', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPcodeList0AService
   */
  success(data: any): void {
    // サーバからの結果を元に、Ｐコードリストデータを更新する
    this.model.getPcodeList(data);
  }
}
